export default __webpack_public_path__ + "static/media/areaIndividual.b5d7b450.png";